var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2929",
    "data-name": "Groupe 2929",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.331,
    height: 18.316,
    viewBox: "0 0 18.331 18.316",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_750",
    "data-name": "Rectangle 750",
    d: "M9.166,0A9.135,9.135,0,1,1,5.6.72,9.137,9.137,0,0,1,9.166,0Z",
    fill: "#e84470"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2916",
    "data-name": "Groupe 2916",
    transform: "translate(4.138 3.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_937",
    "data-name": "Trac\\xE9 937",
    d: "M8.8,9.113H1.687a1.717,1.717,0,0,1-.448-.059,1.644,1.644,0,0,1-.751-.442A1.734,1.734,0,0,1,.051,7.83a1.642,1.642,0,0,1,.021-.871,1.713,1.713,0,0,1,.186-.412L3.83.794A1.7,1.7,0,0,1,4.1.46a1.662,1.662,0,0,1,.73-.406A1.7,1.7,0,0,1,5.258,0h0A1.7,1.7,0,0,1,5.69.055,1.663,1.663,0,0,1,6.42.465,1.7,1.7,0,0,1,6.691.8l3.538,5.753a1.713,1.713,0,0,1,.184.412,1.642,1.642,0,0,1,.018.869,1.733,1.733,0,0,1-.437.781,1.645,1.645,0,0,1-.75.44A1.715,1.715,0,0,1,8.8,9.113ZM5.258.845a.863.863,0,0,0-.214.026.806.806,0,0,0-.361.2.863.863,0,0,0-.135.168L.976,6.993a.852.852,0,0,0-.093.2.816.816,0,0,0-.01.433.862.862,0,0,0,.217.389.817.817,0,0,0,.374.22.853.853,0,0,0,.223.029H8.8a.853.853,0,0,0,.222-.029.818.818,0,0,0,.373-.219.861.861,0,0,0,.217-.388A.817.817,0,0,0,9.6,7.2.852.852,0,0,0,9.509,7L5.971,1.243a.864.864,0,0,0-.135-.169.807.807,0,0,0-.361-.2A.864.864,0,0,0,5.26.845Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_161",
    "data-name": "Groupe 161",
    transform: "translate(4.637 2.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_938",
    "data-name": "Trac\\xE9 938",
    d: "M.171,4.826A.578.578,0,0,1,.1,4.739a.52.52,0,0,1-.053-.1.535.535,0,0,1-.032-.107.645.645,0,0,1,0-.234A.535.535,0,0,1,.043,4.2.52.52,0,0,1,.1,4.1.59.59,0,0,1,.262,3.94a.563.563,0,0,1,.1-.051.62.62,0,0,1,.115-.031.754.754,0,0,1,.126-.01.717.717,0,0,1,.123.01.594.594,0,0,1,.112.031.547.547,0,0,1,.1.051A.585.585,0,0,1,1.1,4.1a.524.524,0,0,1,.052.1.543.543,0,0,1,.031.107.658.658,0,0,1,0,.234.543.543,0,0,1-.031.107.524.524,0,0,1-.052.1.575.575,0,0,1-.073.087A.569.569,0,0,1,.941,4.9a.546.546,0,0,1-.1.051.594.594,0,0,1-.112.031.718.718,0,0,1-.123.01.755.755,0,0,1-.126-.01.62.62,0,0,1-.115-.031.562.562,0,0,1-.1-.051A.577.577,0,0,1,.171,4.826ZM1.107,0,1,3.361H.174L.056,0Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.050cfb22bba65aee04f0bb7456956a34.svg";
export { ForwardRef as ReactComponent };